(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  let copy = {};
  try { copy = JSON.parse($('#JaviTranslations')?.textContent || '{}'); } catch {}
  const storageKey = 'javi-favorites-v1';
  let favorites = [];
  try {
    const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(stored)) favorites = stored.filter(p => p && typeof p.handle === 'string' && typeof p.title === 'string' && typeof p.url === 'string' && p.url.startsWith('/products/'));
  } catch {}
  let toastTimer;
  const toast = message => {
    const element = $('.javi-toast');
    if (!element || !message) return;
    element.textContent = message;
    element.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => element.classList.remove('visible'), 3000);
  };
  const save = () => { try { localStorage.setItem(storageKey, JSON.stringify(favorites)); } catch {} };
  const refreshButtons = () => $$('[data-favorite]').forEach(button => button.setAttribute('aria-pressed', String(favorites.some(p => p.handle === button.dataset.favorite))));
  const renderFavorites = () => {
    const list = $('[data-favorite-list]');
    if (!list) return;
    list.replaceChildren();
    if (!favorites.length) {
      const text = document.createElement('p');
      text.textContent = copy.empty || '';
      list.append(text);
      return;
    }
    for (const product of favorites) {
      const row = document.createElement('div');
      row.className = 'favorite-row';
      const link = document.createElement('a');
      link.href = product.url;
      link.textContent = product.title;
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = '×';
      button.dataset.removeFavorite = product.handle;
      button.setAttribute('aria-label', `${copy.remove || ''} ${product.title}`);
      row.append(link, button);
      list.append(row);
    }
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-favorite]');
    if (button) {
      const exists = favorites.some(p => p.handle === button.dataset.favorite);
      if (exists) favorites = favorites.filter(p => p.handle !== button.dataset.favorite);
      else favorites.push({handle: button.dataset.favorite, title: button.dataset.productTitle, url: button.dataset.productUrl});
      save(); refreshButtons(); toast(exists ? copy.removed : copy.saved);
    }
    const remove = event.target.closest('[data-remove-favorite]');
    if (remove) { favorites = favorites.filter(p => p.handle !== remove.dataset.removeFavorite); save(); refreshButtons(); renderFavorites(); }
    if (event.target.closest('[data-open-favorites]')) { renderFavorites(); $('#JaviFavorites')?.showModal(); }
    if (event.target.closest('[data-close-dialog]')) event.target.closest('dialog')?.close();
    for (const menu of $$('.jv2-menu[open]')) if (!menu.contains(event.target)) menu.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    for (const menu of $$('.jv2-menu[open]')) { menu.open = false; $('summary', menu)?.focus(); }
  });
  $('#JaviFavorites')?.addEventListener('click', event => {
    const dialog = event.currentTarget;
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  document.addEventListener('shopify:section:load', refreshButtons);
  refreshButtons();
  const refreshCart = async () => {
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
      if (!response.ok) return;
      const cart = await response.json();
      $$('[data-cart-count]').forEach(element => element.textContent = cart.item_count);
    } catch {}
  };
  document.addEventListener('cart:update', refreshCart);
  document.addEventListener('shopify:cart:lines-update', async event => {
    try { if (event.promise) await event.promise; await refreshCart(); toast(copy.cart); } catch {}
  });
  window.addEventListener('pageshow', event => { if (event.persisted) { refreshCart(); refreshButtons(); } });
})();
